import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./Features/users/userslice";
import cartReducer from "./Features/cart/cartslice";

const store = configureStore({
  reducer: {
    users: userReducer,
    cart: cartReducer,
  },
});

export default store;
